<template>
  <v-dialog persistent v-model="showCreateDialog" max-width="490">
    <v-card v-if="welcome">
      <v-card-title class="headline">Neues Unternehmen anlegen</v-card-title>
      <v-card-text>
        Geben Sie einen Kurznamen für das neue Unternehmen an. (Der Kurzname erscheint in der Liste der Unternehmen in
        der Seitenleiste.)
      </v-card-text>
      <v-text-field
        filled
        class="mx-4"
        v-model="company.name"
        :counter="140"
        :rules="shortNameRules"
        label="Kurzname"
        placeholder="Kurzname für das Unternehmen"
        v-on:input="did_change = true"
        @keyup.enter="create"
        required
      >
      </v-text-field>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="discard()">
          Abbrechen
        </v-btn>
        <v-btn color="blue darken-1" text @click="create()" :disabled="!company.name">
          Anlegen
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="saving" class="pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Dokument speichern
    </v-card>
    <v-card v-if="done">
      <v-card-title class="headline">Neues Unternehmen angelegt</v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
const createCompany = `mutation CreateCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
  }
}
`;

export default {
  name: "CompanyCreateView",
  props: {
    showThis: Boolean,
  },
  computed: {
    createCompanyMutation() {
      return this.$Amplify.graphqlOperation(createCompany, { input: this.company });
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
  },
  data: () => ({
    company: { name: null },
    welcome: true,
    saving: false,
    done: false,
    showCreateDialog: false,
    shortNameRules: [
      (v) => !!v || "Name des Unternehmens darf nicht leer sein",
      (v) => (v && v.length <= 140) || "Name des Unternehmens darf nicht mehr als 140 Zeichen haben",
    ],
  }),
  watch: {
    showThis: function(st) {
      this.showCreateDialog = st;
      if (st) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.welcome = true;
      this.saving = false;
      this.done = false;
      this.company = { name: null };
    },
    create() {
      this.welcome = false;
      this.saving = true;
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.API.graphql(this.createCompanyMutation)
        .then((response) => {
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Unternehmen",
            entity_label: this.company.name,
            sync_type: "create",
          });

          this.onCreated(response);
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Unternehmen",
            entity_label: this.company.name,
            sync_type: "create",
            error: err.errors[0].message,
          });
          this.discard();
        });
    },
    onCreated(response) {
      this.saving = false;
      this.done = true;
      this.discard();
      var company = response.data.createCompany;
      this.$eventHub.emit("company-created", company);
      this.$router.push({ path: "/app/company/" + company.id });
    },
    discard() {
      this.$emit("discard");
      this.showCreateDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
